module.exports = __webpack_public_path__ + "static/media/article-svi.e5732158.png";